// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfileCardSizingContainer_container__nKcTj","sending":"ProfileCardSizingContainer_sending__FNg3b"};